var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { inline: false, "label-position": "top", size: "small" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "numberSearch",
                      attrs: { label: _vm.$t("collectionCenter.CreationTime") },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "default-time": ["00:00:00", "23:59:59"],
                          "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                          "start-placeholder": _vm.$t("GlobalSetObj.startDate"),
                          "range-separator": "-",
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.queryForm.params.createTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm.params, "createTime", $$v)
                          },
                          expression: "queryForm.params.createTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("navbar.LimitedProblem") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            "collapse-tags": "",
                            filterable: "",
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryForm.params.problemTypeIdList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "problemTypeIdList",
                                $$v
                              )
                            },
                            expression: "queryForm.params.problemTypeIdList",
                          },
                        },
                        _vm._l(_vm.reasonList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.dictDescribe,
                              value: item.problemId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("customerManagements.site") } },
                    [
                      _c("ElSelectV2", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          options: _vm.siteList,
                          placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          clearable: "",
                          "collapse-tags": "",
                          filterable: "",
                          multiple: "",
                          size: "small",
                        },
                        model: {
                          value: _vm.queryForm.params.siteIdList,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm.params, "siteIdList", $$v)
                          },
                          expression: "queryForm.params.siteIdList",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("customerManagements.account"),
                        prop: "userIdList",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            "remote-method": _vm.getAllUserList,
                            clearable: "",
                            "collapse-tags": "",
                            filterable: "",
                            multiple: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: { "visible-change": _vm.openUserList },
                          model: {
                            value: _vm.queryForm.params.userIdList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "userIdList", $$v)
                            },
                            expression: "queryForm.params.userIdList",
                          },
                        },
                        _vm._l(_vm.accountList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.Type") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            "collapse-tags": "",
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryForm.params.restrictTypeList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "restrictTypeList",
                                $$v
                              )
                            },
                            expression: "queryForm.params.restrictTypeList",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("navbar.RegisterProblemDistance"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("navbar.ForcePhoto"),
                              value: 2,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "15px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          icon: "el-icon-search",
                          size: "small",
                          type: "primary",
                        },
                        on: { click: _vm.enterSearch },
                      },
                      [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          icon: "el-icon-refresh-left",
                          size: "small",
                          type: "info",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.resetForm()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.newRestrictions },
                      },
                      [_vm._v(_vm._s(_vm.$t("GlobalSetObj.add")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { plain: "", size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.statusBtn(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("GlobalSetObj.enable")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { plain: "", size: "small", type: "danger" },
                        on: {
                          click: function ($event) {
                            return _vm.statusBtn(0)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("GlobalSetObj.stop")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.exportsTable },
                      },
                      [_vm._v(_vm._s(_vm.$t("operationCenter.exports")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "left",
              type: "selection",
              width: "55",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "70",
            },
          }),
          _vm._l(_vm.tableHeaderList, function (item) {
            return _c("el-table-column", {
              key: item.id,
              attrs: {
                align: item.cloAlign,
                label: item.label,
                "min-width": item.cloWidth,
                prop: item.prop,
                "show-overflow-tooltip": item.isTips,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "statusName"
                          ? _c(
                              "div",
                              [
                                scope.row.status === 1
                                  ? _c("el-tag", [
                                      _vm._v(_vm._s(scope.row.statusName)),
                                    ])
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v(_vm._s(scope.row.statusName))]
                                    ),
                              ],
                              1
                            )
                          : item.prop === "mustDistanceName"
                          ? _c(
                              "div",
                              [
                                scope.row.mustPic === 1
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(_vm.$t("GlobalSetObj.yes"))
                                      ),
                                    ])
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("GlobalSetObj.No"))
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            )
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row[item.prop]
                                    ? "" + scope.row[item.prop]
                                    : "- -"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("newOrder.operation"),
              align: "center",
              fixed: "right",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("GlobalSetObj.edit"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-edit textOperator",
                              on: {
                                click: function ($event) {
                                  return _vm.editData(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        scope.row.status === 0
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.$t("GlobalSetObj.enable"),
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-circle-check textOperator",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateStatus(scope.row)
                                    },
                                  },
                                }),
                              ]
                            )
                          : _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.$t("GlobalSetObj.stop"),
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-remove-outline textOperator1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateStatus(scope.row)
                                    },
                                  },
                                }),
                              ]
                            ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { margin: "10px 0", float: "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [10, 20, 50, 100],
          total: _vm.queryForm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("navbar.RegisterProblemLimitConfiguration"),
            visible: _vm.addDialog,
            top: "5vh",
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
          },
        },
        [
          _c("editConfiguration", {
            key: _vm.configurationKey,
            attrs: {
              "edit-data-form": _vm.editDataForm,
              "edit-site-object": _vm.editSiteObject,
              "other-reason-list": _vm.otherReasonList,
            },
            on: { closeDialog: _vm.closeDialog },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }